





















































































































































import Vue from 'vue';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import { UserService } from '@/services/UserService';
import { UserModel, ValueType, NotificationPresentationType, StandardOrganisation } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import OrganisationSelectList from '@/components/configuration/OrganisationSelectList.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'EditUser',
  mixins: [FormFieldValidation, ModalHelpers],
  data() {
    return {
      isLoading: false,
      user: {} as UserModel,
      submitIsLoading: false,
      hasError: false,
      errorMessage: '',
      organisationProperties: {
        isRequired: true,
        name: 'Organisation',
        validationRule: 'required'
      }
    };
  },
  methods: {
    getData(this: any) {
      this.getUserAsync(this.$route.params.id);
    },
    async onSubmit(this: any) {
      try {
        const isValid = await this.$validator.validate();
        if (isValid) {
          this.submitIsLoading = true;
          try {
            await UserService.updateUserAsync(this.user.id, { ...this.user, authClientId: this.isInternalUser ? this.user.authClientId : null });
            SnotifyConfiguration.showSuccess('User details updated successfully.');
            this.setApplicationDirty(false);
            this.$router.push({ name: 'userManagement' });
          } catch (error) {
            this.submitIsLoading = false;
            this.hasError = true;
          }
        }
      } catch (error) {
        this.$log(error);
      }
    },
    async getUserAsync(id: number) {
      this.isLoading = true;
      UserService.getUserAsync(id)
        .then((result: any) => {
          if (result && !result.canEdit) {
            this.$router.push({
              name: 'errorPage',
              params: {
                errorCode: '401',
                errorMessage: 'Sorry, you do not have permission to edit this user.',
                notificationPresentationType: NotificationPresentationType.UserActionRequired.toString()
              }
            });
          }
          this.user = result;
          this.isLoading = false;
        })
        .catch((error: any) => {
          this.hasError = true;
          this.isLoading = false;
          this.errorMessage = error.notification;
        });
    },
    async onCancel(this: any) {
      this.$router.push({ name: 'userManagement' });
    }
  },
  mounted(this: any) {
    this.getData();
  },
  computed: {
    userIsActive: {
      get(this: any) {
        return !this.user.isDeactivated;
      },
      set(this: any, value: boolean) {
        this.user.isDeactivated = !value;
      }
    },
    isInternalUser(this: any): boolean {
      return this.user?.organisation.id === StandardOrganisation.InternalUsers;
    }
  },
  components: {
    LoadingSpinner,
    OrganisationSelectList,
    SingleSignOnProviderList: () => import('./SingleSignOnProviderList.vue')
  },
  created(this: any) {
    this.UsernameValidation = {
      required: true,
      valueType: ValueType.UserName,
      maxLength: 50
    } as ValidationModel;
    this.EmailValidation = {
      required: true,
      valueType: ValueType.Email
    } as ValidationModel;
  }
});
